// src/pages/Oversized.js
import React, { useState, useEffect, useRef } from 'react';
import './Oversized.css';

const Oversized = () => {
  const [formData, setFormData] = useState({ name: '', phone: '' });
  const [responseMsg, setResponseMsg] = useState('');

  // Состояния для анимированных цифр
  const numbersRef = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);
  const [counts, setCounts] = useState([0, 0, 0, 0]); // начальные значения

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('http://localhost:5000/api/requests', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, tab: 'oversized' }),
      });
      const data = await response.json();
      if (response.ok) {
        setResponseMsg(data.message || 'Заявка успешно отправлена!');
        setFormData({ name: '', phone: '' });
      } else {
        setResponseMsg(data.message || 'Ошибка при отправке');
      }
    } catch (err) {
      console.error(err);
      setResponseMsg('Ошибка подключения к серверу');
    }
  };

  // Наблюдение за секцией с цифрами для запуска анимации
  useEffect(() => {
    const currentRef = numbersRef.current;
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting && !hasAnimated) {
        setHasAnimated(true);
      }
    }, { threshold: 0.3 });
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [hasAnimated]);

  // Анимация счётчиков
  useEffect(() => {
    if (hasAnimated) {
      const finalValues = [500, 2000, 1200, 20]; // конечные значения для анимации
      const increments = finalValues.map(value => Math.ceil(value / 50));
      let frame = 0;
      const animate = () => {
        frame++;
        setCounts(prev =>
          prev.map((num, i) => {
            const next = num + increments[i];
            return next >= finalValues[i] ? finalValues[i] : next;
          })
        );
        if (frame < 50) {
          requestAnimationFrame(animate);
        }
      };
      requestAnimationFrame(animate);
    }
  }, [hasAnimated]);

  return (
    <div className="oversized-page">
      {/* Шапка */}
      <header className="oversized-header">
        <div className="header-overlay">
          <h1>Негабаритные перевозки</h1>
          <p></p>
        </div>
      </header>
      <section className="oversized-request">
        <div className="container">
          <h2>Оставьте заявку на негабаритную перевозку</h2>
          <p>Наш менеджер свяжется с вами для уточнения всех деталей</p>
          <form className="request-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Ваше имя"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Ваш телефон"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <button type="submit">Отправить заявку</button>
          </form>
          {responseMsg && <p className="response-message">{responseMsg}</p>}
          <p className="disclaimer">
            Нажимая на кнопку, вы соглашаетесь на обработку персональных данных
          </p>
        </div>
      </section>
      {/* Информация */}
      <section className="oversized-info">
        <div className="container">
          <h2>Какие грузы мы перевозим ?</h2>

          <div className="category-card">
            <h3>Дорожно-строительная техника:</h3>
            <ul>
              <li>Экскаваторы-погрузчики</li>
              <li>Грейдеры</li>
              <li>Катки</li>
              <li>Бульдозеры</li>
              <li>Автомобильные краны</li>
            </ul>
          </div>

          <div className="category-card">
            <h3>Спецтехника:</h3>
            <ul>
              <li>Грузовая</li>
              <li>Пожарная</li>
              <li>Производственная</li>
              <li>Сельскохозяйственная</li>
            </ul>
          </div>

          <div className="category-card">
            <h3>Металлоконструкции:</h3>
            <ul>
              <li>Емкости</li>
              <li>Модульные сооружения</li>
              <li>Карьерное оборудование</li>
            </ul>
          </div>
        </div>
      </section>


      {/* Наши преимущества */}
      <section className="oversized-advantages">
        <div className="container">
          <h2>Наши преимущества</h2>
          <div className="advantages-grid">
            <div className="advantage-item">
              <h3>Опыт и экспертиза</h3>
              <p>Многолетний опыт в сфере негабаритных перевозок и надёжные партнёры.</p>
            </div>
            <div className="advantage-item">
              <h3>Безопасность</h3>
              <p>Строгое соблюдение всех норм и правил, страхование груза на каждом этапе.</p>
            </div>
            <div className="advantage-item">
              <h3>Индивидуальный подход</h3>
              <p>Разработка маршрута и графика доставки с учётом особенностей груза.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Схема работы */}
      <section className="oversized-scheme">
        <div className="container">
          <h2>Схема работы</h2>
          <div className="scheme-steps">
            <div className="scheme-step">
              <div className="scheme-icon step-icon-1"></div>
              <p>Принимаем заявку</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-2"></div>
              <p>Разрабатываем маршрут</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-3"></div>
              <p>Получаем разрешения</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-4"></div>
              <p>Выполняем перевозку</p>
            </div>
            <div className="scheme-step">
              <div className="scheme-icon step-icon-5"></div>
              <p>Доставляем груз</p>
            </div>
          </div>
        </div>
      </section>

      {/* Форма заявки */}
      <section className="contacts-section">
        <div className="container contacts-container">
          <div className="contacts-info">
            <div className="contact-item address">
              <span>Калужская область, Боровский район, п. Ворсино</span>
            </div>
            <div className="contact-item email">
              <span>amlogistic40@mail.ru</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Oversized;
